import './TableActionButtonGroup.scss';

import React, { FC, MouseEvent } from 'react';
import { Button } from 'react-bootstrap';
import ButtonGroup from 'react-bootstrap/esm/ButtonGroup';
import { Link } from 'react-router-dom';

interface TableActionButtonGroupProps {
  entityContainerUrl: string;
  entityId: number;
  onDelete: (id: number) => void;
  isViewEnabled?: boolean;
}

const TableActionButtonGroup: FC<TableActionButtonGroupProps> = ({
  entityContainerUrl,
  entityId,
  onDelete,
  isViewEnabled,
}) => {

  const viewEnabled = typeof isViewEnabled !== 'undefined' && isViewEnabled;

  const deleteMessage =
    'Are you sure you want to delete this record?  This action is unreversible. ';

  return (
    <div className="TableActionButtonGroup">
      <ButtonGroup aria-label="Document Actions">
        {viewEnabled ? (
        <Link
          to={`/${entityContainerUrl}/view/${entityId}`}
          className="btn btn-primary"
          title="View"
        >
          <i className="bi bi-eye" />
        </Link>) : 
        (<>&nbsp;</>) 
        }
        <Link
          to={`/${entityContainerUrl}/edit/${entityId}`}
          className="btn btn-secondary"
          title="Edit"
        >
          <i className="bi bi-pencil" />
        </Link>
        <Button
          variant="danger"
          title="Delete"
          onClick={(event: MouseEvent) => {
            event.preventDefault();
            // eslint-disable-next-line no-alert
            if (window.confirm(deleteMessage)) {
              onDelete(entityId);
            }
          }}
        >
          <i className="bi bi-trash" />
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default TableActionButtonGroup;
